import { useAuth } from "contexts/AuthContext";

const useHeaders = () => {
  const { getHeaders } = useAuth();
  return getHeaders();
};

export default useHeaders;
